import type { DeepPartial } from '@luna/utils-ts';

import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsATFeatureConfig: DeepPartial<ProductSettings> = {
    showAccountInfo: true,
    showFeesIncludedSetting: true,
    showTradingActivation: true,
};
